import Constants from "expo-constants";

export function isTestMode() {
  return Constants.manifest?.extra?.testMode === true;
}
